(function () {
  var phone = window.matchMedia('(max-width: 900px)');

  // Phone menu drawer: close when a link is tapped or when tapping outside
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      if (drawer.hasAttribute('open') && !drawer.contains(e.target)) drawer.removeAttribute('open');
    });
  }

  // Desktop department menus: Escape closes the open panel
  document.querySelectorAll('.dept').forEach(function (d) {
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        d.classList.add('is-closed');
        var tab = d.querySelector('.dept-tab');
        if (tab) tab.focus();
      }
    });
    d.addEventListener('mouseleave', function () { d.classList.remove('is-closed'); });
    d.addEventListener('focusout', function (e) { if (!d.contains(e.relatedTarget)) d.classList.remove('is-closed'); });
  });

  // Collection filters: open on desktop, collapsed on phones
  document.querySelectorAll('[data-filters]').forEach(function (f) {
    function setOpen() { if (phone.matches) f.removeAttribute('open'); else f.setAttribute('open', ''); }
    setOpen();
    if (phone.addEventListener) phone.addEventListener('change', setOpen);
  });
  document.querySelectorAll('[data-auto-submit]').forEach(function (box) {
    box.addEventListener('change', function () { box.form.submit(); });
  });

  // Product rows: arrow buttons scroll the row
  document.querySelectorAll('[data-row]').forEach(function (row) {
    var wrap = row.closest('.pane');
    function go(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); }
    var prev = wrap && wrap.querySelector('[data-row-prev]');
    var next = wrap && wrap.querySelector('[data-row-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  });

  // Highlight today's row in any store-hours table
  var day = new Date().getDay();
  document.querySelectorAll('.hours tr[data-d="' + day + '"]').forEach(function (row) {
    row.classList.add('today');
  });

  // Mark the menu item for the on-page section in view (home page anchor links)
  var links = [].slice.call(document.querySelectorAll('.dept-bar .xlink[href*="#"]'));
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) {
          a.classList.toggle('on', a.hash === '#' + e.target.id);
        });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) {
      if (!a.hash || a.pathname !== location.pathname) return;
      var t = document.getElementById(a.hash.slice(1));
      if (t) io.observe(t);
    });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.main-img img');
    g.querySelectorAll('.thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || '';
        g.querySelectorAll('.thumbs button').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variant picker: update price + button state from the selected option
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    var form = sel.closest('form');
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form && form.querySelector('[data-add-btn]');
    function sync() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.getAttribute('data-price')) priceEl.innerHTML = opt.getAttribute('data-price');
      if (btn) {
        var ok = opt.getAttribute('data-available') === 'true';
        btn.disabled = !ok;
        btn.textContent = ok ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      }
    }
    sel.addEventListener('change', sync);
    sync();
  });

  // Collection sort dropdown
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });
  });
})();

/* ---------- Drops, events, countdowns, appointment slots ---------- */
(function () {
  function parseLocal(str) {
    // "2026-11-07T10:00" -> local Date
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:T(\d{1,2}):(\d{2}))?/.exec((str || '').trim());
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
  }
  var now = new Date();

  // Countdowns
  var cds = [].slice.call(document.querySelectorAll('[data-countdown]'));
  function tick() {
    var t = new Date();
    cds.forEach(function (el) {
      var when = parseLocal(el.getAttribute('data-countdown'));
      if (!when) { el.hidden = true; return; }
      var ms = when - t;
      if (ms <= 0) { el.innerHTML = '<span class="cd-live">★ LIVE NOW ★</span>'; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, mi = Math.floor(ms / 6e4) % 60, se = Math.floor(ms / 1e3) % 60;
      function seg(n, l) { return '<span class="cd-seg"><b>' + (n < 10 ? '0' : '') + n + '</b><i>' + l + '</i></span>'; }
      el.innerHTML = seg(d, 'days') + seg(h, 'hrs') + seg(mi, 'min') + seg(se, 'sec');
    });
  }
  if (cds.length) { tick(); setInterval(tick, 1000); }

  // Home "What's On": show only the next upcoming item in each card
  document.querySelectorAll('[data-next-list]').forEach(function (list) {
    var items = [].slice.call(list.querySelectorAll('.wo-item'));
    var upcoming = items.map(function (el) { return { el: el, when: parseLocal(el.getAttribute('data-when')) }; })
      .filter(function (x) { return x.when && x.when > now; })
      .sort(function (a, b) { return a.when - b.when; });
    items.forEach(function (el) { el.hidden = true; });
    var none = list.querySelector('.wo-none');
    if (upcoming.length) { upcoming[0].el.hidden = false; if (none) none.hidden = true; }
    else if (none) none.hidden = false;
  });

  // Drops / events pages: sort by date, move past ones into "Past"
  document.querySelectorAll('[data-cal-list]').forEach(function (list) {
    var pane = list.closest('.pane');
    var pastBox = pane && pane.querySelector('[data-cal-past]');
    var pastList = pane && pane.querySelector('[data-cal-past-list]');
    var empty = pane && pane.querySelector('[data-cal-empty]');
    var items = [].slice.call(list.children).map(function (el) {
      return { el: el, when: parseLocal(el.getAttribute('data-when')), end: parseLocal(el.getAttribute('data-end')) };
    });
    var up = [], past = [];
    items.forEach(function (x) {
      var isDrop = x.el.classList.contains('cal-drop');
      var status = x.el.querySelector('[data-status]');
      var finished = isDrop ? false : (x.end && x.end < now);
      var started = x.when && x.when <= now;
      if (isDrop) {
        // a drop stays "live" for 7 days, then moves to Past
        var liveUntil = x.when ? new Date(x.when.getTime() + 7 * 864e5) : null;
        finished = liveUntil && liveUntil < now;
      }
      x.el.querySelectorAll('[data-live-only]').forEach(function (n) { n.hidden = isDrop && !started; });
      x.el.querySelectorAll('[data-upcoming-only]').forEach(function (n) { n.hidden = !!finished || (isDrop && started); });
      if (status) {
        status.textContent = finished ? (isDrop ? 'DROPPED' : 'PAST') : started ? (isDrop ? 'LIVE NOW' : 'HAPPENING NOW') : 'UPCOMING';
        status.className = 'cal-status ' + (finished ? 'is-past' : started ? 'is-live' : 'is-up');
      }
      (finished ? past : up).push(x);
    });
    up.sort(function (a, b) { return (a.when || 0) - (b.when || 0); }).forEach(function (x) { list.appendChild(x.el); });
    if (pastList) past.sort(function (a, b) { return (b.when || 0) - (a.when || 0); }).forEach(function (x) { x.el.classList.add('is-past'); pastList.appendChild(x.el); });
    if (pastBox) pastBox.hidden = past.length === 0;
    if (empty) empty.hidden = up.length > 0;
  });

  // Appointment / pick-up slot pickers
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function hm(str, fallback) {
    var m = /^(\d{1,2}):?(\d{2})?/.exec((str || '').trim());
    return m ? (+m[1]) * 60 + (+(m[2] || 0)) : fallback;
  }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }
  function fmtDay(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
  }
  function ymd(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  window.LotusSlots = function (cfg, nowDate) {
    // returns [{day: Date, label, times: [label...]}]
    var open = hm(cfg.open, 600), close = hm(cfg.close, 1080), step = Math.max(5, +cfg.step || 30);
    var lead = (+cfg.lead || 0) * 6e4 * 60, ahead = Math.max(1, +cfg.ahead || 14);
    var days = (cfg.days || '').toLowerCase().split(',').map(function (s) { return s.trim().slice(0, 3); }).filter(Boolean);
    var closed = (cfg.closed || '').split(/[,\s]+/).filter(Boolean);
    var earliest = new Date(nowDate.getTime() + lead), out = [];
    for (var i = 0; i <= ahead; i++) {
      var d = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + i);
      if (days.length && days.indexOf(DAYS[d.getDay()]) === -1) continue;
      if (closed.indexOf(ymd(d)) !== -1) continue;
      var times = [];
      for (var t = open; t + step <= close; t += step) {
        var slot = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(t / 60), t % 60);
        if (slot >= earliest) times.push(fmtTime(t) + ' – ' + fmtTime(t + step));
      }
      if (times.length) out.push({ day: d, label: fmtDay(d), times: times });
    }
    return out;
  };
  document.querySelectorAll('[data-slot-picker]').forEach(function (box) {
    var ds = box.dataset;
    var slots = window.LotusSlots({ open: ds.open, close: ds.close, step: ds.step, lead: ds.lead, ahead: ds.ahead, days: ds.days, closed: ds.closed }, new Date());
    var daySel = box.querySelector('[data-slot-date]'), timeSel = box.querySelector('[data-slot-time]');
    var empty = box.querySelector('.slot-empty');
    if (!slots.length) { if (empty) empty.hidden = false; daySel.disabled = true; daySel.required = false; timeSel.required = false; return; }
    slots.forEach(function (s, i) {
      var o = document.createElement('option'); o.value = s.label; o.textContent = s.label; o.dataset.i = i;
      if (s.label === ds.currentDay) o.selected = true;
      daySel.appendChild(o);
    });
    function fill() {
      var opt = daySel.options[daySel.selectedIndex];
      timeSel.innerHTML = '';
      if (!opt || opt.value === '') {
        timeSel.disabled = true;
        timeSel.innerHTML = '<option value="">Pick a day first</option>';
        return;
      }
      timeSel.disabled = false;
      var first = document.createElement('option'); first.value = ''; first.textContent = 'Pick a time'; timeSel.appendChild(first);
      slots[+opt.dataset.i].times.forEach(function (t) {
        var o = document.createElement('option'); o.value = t; o.textContent = t;
        if (t === ds.currentTime) o.selected = true;
        timeSel.appendChild(o);
      });
    }
    daySel.addEventListener('change', fill);
    fill();
  });
})();
